import React from 'react';

const VSideBarMenuIcon = ({ className, width = '16', height = '16' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33337 2.66659C2.96518 2.66659 2.66671 2.96506 2.66671 3.33325V12.6666C2.66671 13.0348 2.96518 13.3333 3.33337 13.3333H12.6667C13.0349 13.3333 13.3334 13.0348 13.3334 12.6666V3.33325C13.3334 2.96506 13.0349 2.66659 12.6667 2.66659H3.33337ZM1.33337 3.33325C1.33337 2.22868 2.2288 1.33325 3.33337 1.33325H12.6667C13.7713 1.33325 14.6667 2.22868 14.6667 3.33325V12.6666C14.6667 13.7712 13.7713 14.6666 12.6667 14.6666H3.33337C2.2288 14.6666 1.33337 13.7712 1.33337 12.6666V3.33325Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00004 1.33325C6.36823 1.33325 6.66671 1.63173 6.66671 1.99992V13.9999C6.66671 14.3681 6.36823 14.6666 6.00004 14.6666C5.63185 14.6666 5.33337 14.3681 5.33337 13.9999V1.99992C5.33337 1.63173 5.63185 1.33325 6.00004 1.33325Z" fill="currentColor" />
        </svg>
    )
}

export default VSideBarMenuIcon;

